import { all } from 'redux-saga/effects'

import { listSaga } from './list/saga'

export function* jobsSaga() {
  yield all([listSaga()])
}
